import {
  IWizardConfig,
  WizardMode,
  SubmitButtonColor,
} from "../../../wizard/types";
import useStudentsQueries from "../../hooks/useManagedStudentsQueries";
import { EditProfileForm } from "../../../user/userAccount/modals/EditProfile/EditProfileForm";
import { formValidator } from "../../../user/userAccount/modals/EditProfile/validators";
import { UserRole } from "../../../user/enums/UserRole";
import { parseToAccountBackEndModel } from "../../../user/userAccount/modals/helpers/parseToAccountBackEndModel";
import { objectToFormData } from "../../../../utils/objectToFormData";

function addStudent(data, createStudent) {
  const parsedData = objectToFormData(
    parseToAccountBackEndModel(data, UserRole.Student),
  );

  return createStudent(parsedData);
}

export function useAddStudentConfig() {
  const { createStudent } = useStudentsQueries();

  const getAddStudentConfig = (): IWizardConfig => ({
    steps: [
      {
        width: "568px",
        titleConfig: {
          titleText: "Add Student",
        },
        content: EditProfileForm,
        validator: formValidator(UserRole.Student),
      },
    ],
    submitButtonText: "Save",
    submitButtonColor: SubmitButtonColor.Success,
    saveCallback: (data) => addStudent(data, createStudent),
    mode: WizardMode.Create,
    getInitialData: async () => ({
      role: UserRole.Student,
    }),
  });

  return {
    getAddStudentConfig,
  };
}
